import { facebookNotificationsCheck } from 'utils/headerSettingsAlert/checks/facebookNotifications';
import { messagesQuotaCheck } from 'utils/headerSettingsAlert/checks/messagesQuota';
import { missingSuperAdminCheck } from 'utils/headerSettingsAlert/checks/missingSuperAdmin';
import type { HeaderSettingsAlertContext, HeaderSettingsAlertIssue } from 'utils/headerSettingsAlert/types';

export type { HeaderSettingsAlertCheck, HeaderSettingsAlertContext, HeaderSettingsAlertIssue } from 'utils/headerSettingsAlert/types';

/**
 * רשימת בדיקות לבאדג' סטטוס הגדרות בכותרת.
 * להוספת מקרה חדש: צור check ב־checks/ והוסף לרשימה.
 */
export const HEADER_SETTINGS_ALERT_CHECKS = [
  facebookNotificationsCheck,
  missingSuperAdminCheck,
  messagesQuotaCheck,
] as const;

export function evaluateHeaderSettingsAlerts(ctx: HeaderSettingsAlertContext): HeaderSettingsAlertIssue[] {
  return HEADER_SETTINGS_ALERT_CHECKS.flatMap((check) => check.run(ctx));
}
